import { useMutation } from '@tanstack/react-query'
import { fetchG2Token } from 'src/queries/g2/g2.network'
import { g2QueryKeys } from 'src/queries/queries.constants'

export const useG2TokenMutation = () => {
  return useMutation({
    mutationFn: () => fetchG2Token(),
    mutationKey: g2QueryKeys.token(),
  })
}
